const yjMeterPrefix = (s) => String(s ?? '').trim().toUpperCase().startsWith('YJ');

/** 是否按 4G 表处理：后端通讯类型为 4G，或当前/厂商表号以 YJ 开头（不区分大小写） */
export function isDevice4GMeter(device) {
  if (!device) return false;
  if (Number(device.communication_type) === 0) return true;
  return yjMeterPrefix(device.current_meter_no) || yjMeterPrefix(device.factory_meter_no);
}

/** 通讯类型为 WIFI（2），协议以模组串口 AT+MQTTPUB 日志为准，非 4G YJ 远程 */
export function isWifiMeter(device) {
  return !!device && Number(device.communication_type) === 2;
}

/** 设备厂家为 ZT（不区分大小写；展示名可能为「厂家一」） */
export function isZtManufacturer(device) {
  if (!device) return false;
  return String(device.manufacturer || '').trim().toUpperCase() === 'ZT';
}

/** BY 厂家电表 */
export function isByManufacturer(device) {
  if (!device) return false;
  return String(device.manufacturer || '').trim().toUpperCase() === 'BY';
}

/** 取表号（优先当前表号） */
export function deviceMeterNo(device) {
  if (!device) return '';
  return String(device.current_meter_no || device.imei || device.factory_meter_no || '').trim();
}

/**
 * 设备详细类型文案：
 * - BY：按表号前缀 172=母表 / 161=子表（不看 device_detail_type）
 * - 其它 4G：沿用 4G主表 / 蓝牙副表
 */
export function formatElectricDetailTypeLabel(device) {
  if (!device || !isDevice4GMeter(device)) return '';
  if (isByManufacturer(device)) {
    const no = deviceMeterNo(device);
    if (no.startsWith('172')) return '母表';
    if (no.startsWith('161')) return '子表';
    return 'BY电表';
  }
  return Number(device.device_detail_type) === 1 ? '4G主表' : '蓝牙副表';
}

/** 当前/厂商表号以 YJ 开头（不区分大小写） */
export function isYjMeterNumber(device) {
  if (!device) return false;
  return yjMeterPrefix(device.current_meter_no) || yjMeterPrefix(device.factory_meter_no);
}

/**
 * 管理端水表：远程补水量 + 55 计量系数（YJ 协议能力，且非 ZT 厂家表）
 * ZT 走平台侧另一套逻辑，不显示上述两项。
 */
export function isYjWaterRemoteSupplementEligible(device) {
  return isDevice4GMeter(device) && isYjMeterNumber(device) && !isZtManufacturer(device);
}
